module.exports = __webpack_public_path__ + "img/jindo-free-coin.fc24946d.png";